import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { QnSbnDataService } from '../services/qn-sbn-data-service.service';
import { QnSbnService } from '../services/qn-sbn-service.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { FileFormatDialogComponent } from '../notification/file-format-dialog/file-format-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import * as XLSX from 'xlsx';

@Component({
  selector: 'dl-rexis-sap-dialog',
  templateUrl: './rexis-sap-dialog.component.html',
  styleUrls: ['./rexis-sap-dialog.component.scss']
})

export class RexisSapDialogComponent implements OnInit {
  public previousMapptedData: any = [];
  public mappedData: any = [];
  public countryCode: string = "";
  public materialNo: string  = "";
  public reagentMaterialNo: any  = [];
  public batchNo: any  = [];
  public dateFrom: Date|null = null;
  public dateTo: Date|null = null;
  public contactRole: string = "";
  public records: string = "";
  public contactAttrType: string  = "any";
  public contactAttrValue: string = "";
  public title: string = "Contacts";
  public accountsSource: string = "none";
  public contactsSource: string = "none";
  public showAccountsByIntrument: boolean = false;
  public showAccountsByShipments: boolean = false; 
  public showContactsByInstrument: boolean = false;
  public showContactsBySafetyAndQuality: boolean = false;
  public requestEnabled: boolean = false;
  // public countryCodes = ['GB','IE','AR','CA','ES','US','PY','UY','PT','BR','DO','IN','MX','PT','NI','HR','GT','CZ','CO','CL','PA','AT']
  public countryCodes: any = [];
  public countryCodeFC = new FormControl(this.countryCode, [Validators.required]);
  public affAccFC = new FormControl(this.accountsSource);
  public instruMatFC = new FormControl(this.materialNo, [Validators.required]);
  public batchNumFC = new FormControl(this.batchNo);
  public datepickeFromFC = new FormControl(this.dateFrom, [Validators.required]);
  public datepickeToFC = new FormControl(this.dateTo, [Validators.required]);
  public contactFC = new FormControl(this.contactsSource);
  public attTypFC = new FormControl(this.contactAttrType);
  public attValFC = new FormControl(this.contactAttrValue);
  public contRolFC = new FormControl(this.contactRole);
  public notificationData: any;
  public selectedData: any = [];
  public isDisabled: boolean = false;
  public cancelled: boolean = false;
  public instrumentStatus: string = "none";
  public instrumentStatusFC = new FormControl(this.instrumentStatus);
  public shipPartnerRole: any = ["all"];
  public shipPartnerRoleFC = new FormControl(this.shipPartnerRole)
  public allRoles = ["all", "ag", "re", "rg", "sp", "y1", "y2", "we"];
  public allSelected = false;
  public allShipSelected = false;
  public checked: boolean = false;
  public instrumentMaterialNumber: any = [];
  public instrumentMaterials: any = [];
  public reagentMaterialBatchNumber: any =[];
  public materialBatchNo : any = [];
  public materialBatchNoValue : any = [];
  public reagentMaterialNoValue: any = [];
  public batchVal: any = [];

  constructor(
    public  dialogRef: MatDialogRef<RexisSapDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public rexSapDialogData: any,
    public  QnSbnService: QnSbnService,
    public  qnSbnDataService: QnSbnDataService,
    public  changeDetector: ChangeDetectorRef,
    private readonly oneSnackBar?: OneSnackBarService,
    public readonly dialog?: MatDialog, 
  ) { }

  public ngOnInit(): void {
    const countryDiaInp = this.rexSapDialogData?.Country;
    
    this.qnSbnDataService.mappingData$.subscribe(
      res => {
        if(!this.qnSbnDataService.isEmpty(res)){
          this.notificationData = res;
          this.countryCode = this.notificationData.localNotificationId.Country;
          this.countryCodeFC.patchValue(this.countryCode);
          this.countryCodes.push(this.countryCode);
        }else if(countryDiaInp){
          this.countryCode = countryDiaInp;
          this.countryCodeFC.patchValue(this.countryCode);
          this.countryCodes.push(this.countryCode);
        }
      } 
    );
    if(!this.countryCode){
      this.oneSnackBar.open('Country code is unavailable. Please reopen the notification again', OneSnackBarType.ERROR, '', { duration: 5000 });
    }
    this.addInstrumentField();
    this.addReagentBatchField();
    this.shipPartnerRoleFC.setValue(this.allRoles);
  }

  public delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public async request() {
    this.isDisabled = true;
    this.previousMapptedData = this.mappedData;
    this.mappedData = [];
    this.records = "Requesting data...";
    try
    {
      let allCompleted = false;

      const resForTaskId = await this.QnSbnService.getRexSapTaskId(
        this.countryCode, 
        this.accountsSource,
        this.contactsSource,
        this.instrumentMaterialNumber,
        this.reagentMaterialNoValue,
        this.materialBatchNoValue,
        //this.batchVal,
        this.dateFrom, 
        this.dateTo,
        (this.contactAttrType == "any" ? "" : this.contactAttrType),
        this.contactAttrValue,
        this.contactRole,
        this.instrumentStatus,
        this.shipPartnerRole
      );
      
      if(resForTaskId.statusCode === 202){

        while (!allCompleted && !this.cancelled) {
  
          await this.delay(4000);
          
          const resForData = await this.QnSbnService.getRexSapPolling(resForTaskId.body.taskId);
          
          if(resForData.statusCode === 200){

            allCompleted = resForData?.body?.allCompleted;

            const overallProgress = resForData?.body?.overallProgress;
            
            const rexSapData = resForData?.body?.finalResult;
    
            this.mappedData = this.joinData(rexSapData, this.previousMapptedData);
            
            if (rexSapData != null && rexSapData.length > 0) {
              rexSapData.forEach((item: any) =>{
                item.checked = item.erpAccountNo && item.accountName && item.contactEmail;
              });
              this.selectedData = this.mappedData.filter((item: any) => item.checked);
            }

            if(allCompleted && overallProgress === '100.00' && rexSapData.length > 0){
              this.records = 'Completed';
            }else if(allCompleted && overallProgress === '100.00'  && rexSapData.length <= 0){
              this.isDisabled = false;
              this.records = 'No Data Found';
            }else{
              this.isDisabled = false;
              this.records = `Progress is ${overallProgress}%`;
            }

          }else{
            this.isDisabled = false;
            this.records = "Error occurred";
            allCompleted = resForData?.body?.allCompleted || true;
            this.oneSnackBar.open('Please request again later', OneSnackBarType.ERROR, '', { duration: 5000 });
          }
          
        }
      }else{
        this.isDisabled = false;
        this.records = "Error occurred";
        this.oneSnackBar.open('Please request again later', OneSnackBarType.ERROR, '', { duration: 5000 });
      }
    }
    catch (error) {
      this.isDisabled = false;
      this.records = "Error occurred";
      if(error.status === 400){
        this.oneSnackBar.open('No Sales Organization ID has been defined for your user group. Please contact the P&SC team to set one.', OneSnackBarType.ERROR, '', { duration: 5000 });
      }else{
        this.oneSnackBar.open('Please request again later', OneSnackBarType.ERROR, '', { duration: 5000 });
      }
    }
  }

  public clear() {
    this.mappedData = [];
    this.records = "";
    this.isDisabled = false;
  }

  public joinData(data: any, previousData: any) : any {
    if (previousData == null || previousData.length == 0){
      data.sort((a: any, b: any) => {
        if (a.accountName < b.accountName) return -1;
        if (a.accountName > b.accountName) return 1;
        if (a.contactName < b.contactName) return -1;
        if (a.contactName > b.contactName) return 1;
        return 0;
      });
      return data;
    } 

    // Create a copy of previous data
    let result = previousData.map((item: any) => {
      return { ...item };
    });

    // unique values are pushed from data to result
    data.forEach((item: any) => {
      const existingItem = result.some(
        (resultItem: any) =>{
          return resultItem?.crmAccountNo == item?.crmAccountNo
          && resultItem?.erpAccountNo == item?.erpAccountNo
          && resultItem?.accountName == item?.accountName 
          && resultItem?.contactName == item?.contactName
          && resultItem?.contactEmail == item?.contactEmail 
          && resultItem?.contactRole == item?.contactRole
          && resultItem?.safetyAndQuality?.qualityNotification == item?.safetyAndQuality?.qualityNotification
          && resultItem?.safetyAndQuality?.safetyBoardNotification == item?.safetyAndQuality?.safetyBoardNotification
          && resultItem?.safetyAndQuality?.supportNotification == item?.safetyAndQuality?.supportNotification
        } 
      );
      
      if (!existingItem) {
        result.push(item);
      }
    });

    // Order by accountName and contactName
    result.sort((a: any, b: any) => {
      if (a.accountName < b.accountName) return -1;
      if (a.accountName > b.accountName) return 1;
      if (a.contactName < b.contactName) return -1;
      if (a.contactName > b.contactName) return 1;
      return 0;
    });

    return result;
  }

  public onCountryCodeValueChange(event: any) {
    this.countryCode = event;
    this.requestEnabled = this.isRequestEnabled();
  }

  public onMaterialNoValueChange(event: any, i) {
    this.materialNo = event.target.value.replace(/\s+/g,'').trim();
    this.instrumentMaterialNumber[i] = this.materialNo;
    this.requestEnabled = this.isRequestEnabled();
  }

  // public onReagentMaterialNoValueChange(event: any, i) {
  //   this.reagentMaterialNo = event.target.value;
  //   this.requestEnabled = this.isRequestEnabled();
  // }

  // public onBatchNoValueChange(event: any) {
  //   this.batchNo = event.target.value;
  // }

  public onDateFromValueChange(event: any) {
    this.dateFrom = event.target.value;
    this.requestEnabled = this.isRequestEnabled();

    if(this.dateFrom > this.dateTo){
      this.datepickeToFC.reset();
      this.clearButton('datepickeToFC');
    }
  }

  public onDateToValueChange(event: any) {
    this.dateTo = event.target.value;
    this.requestEnabled = this.isRequestEnabled();
  }

  public onAccountsSourceValueChange(event: any) {
    this.accountsSource = event;
    this.showAccountsByIntrument = this.accountsSource == "instrument";
    this.showAccountsByShipments = this.accountsSource == "shipments";

    if(this.showAccountsByShipments){
      const today = new Date();
      today.setFullYear(today.getFullYear() - 2);
      const twoYearsAgo = today.toISOString().split('T')[0];
      this.datepickeFromFC.patchValue(twoYearsAgo);
      this.datepickeToFC.patchValue(new Date());
      this.dateFrom = new Date(twoYearsAgo);
      this.dateTo = new Date();
      this.instrumentMaterials = [{ control: new FormControl('') }];
      this.instrumentMaterialNumber = [];
      this.shipPartnerRoleFC.setValue(this.allRoles);
      this.shipPartnerRole = "all";
      this.instruMatFC.reset();
      this.materialNo = '';

      this.instrumentStatusFC.setValue("none");
      this.instrumentStatus = "none";
    }

    if(this.showAccountsByIntrument){
      this.reagentMaterialNo = [];
  
      // this.batchNumFC.reset();
      // this.batchNo = '';

      this.datepickeFromFC.reset();
      this.dateFrom = null;

      this.datepickeToFC.reset();
      this.dateTo = null;

      this.shipPartnerRoleFC.reset();
      this.shipPartnerRole = [];

      this.reagentMaterialBatchNumber = [];
      this.reagentMaterialBatchNumber.push({
        reagentMaterialNumber: new FormControl('', [Validators.required]),
        batchNumber: new FormControl('', [Validators.required])
      });
      this.reagentMaterialNoValue = [];
      this.materialBatchNoValue = [];
      this.materialBatchNo = [];

      this.instrumentStatusFC.setValue("none");
      this.instrumentStatus = "none";
    }

    this.requestEnabled = this.isRequestEnabled();
  }

  public onContactsSourceValueChange(event: any) {
    this.contactsSource = event;
    this.showContactsByInstrument = this.contactsSource == "instrument";
    this.showContactsBySafetyAndQuality = this.contactsSource == "safetyAndQuality";
    
    if(this.showContactsBySafetyAndQuality){
      this.instruMatFC.reset();
      this.materialNo = '';

      this.contRolFC.reset();
      this.contactRole = '';
      
      this.instrumentStatusFC.setValue("none");
      this.instrumentStatus = "none";
    }

    if(this.showContactsByInstrument){
      this.attTypFC.reset();
      this.contactAttrType = "any";
      
      this.attValFC.reset();
      this.contactAttrValue = "";
  
      this.contRolFC.reset();
      this.contactRole = '';

      this.instrumentStatusFC.setValue("none");
      this.instrumentStatus = "none";
    }

    this.requestEnabled = this.isRequestEnabled();
  }

  public onInstrumentStatusChange(event:any){
    this.instrumentStatus = event;
  }

  public onContactAttrTypeValueChange(event: any) {
    this.contactAttrType = event;
  }

  public onContactAttrValueValueChange(event: any) {
    this.contactAttrValue = event.target.value;
  }

  public onContactRoleValueChange(event: any) {
    this.contactRole = event.target.value;
  }

  private isRequestEnabled() {
    if (this.countryCode == "") return false;
    if (this.accountsSource == "none" && this.contactsSource == "none") return false;
    if (this.accountsSource == "instrument" && this.instrumentMaterialNumber == "") return false;
    if (this.accountsSource == "shipments" && this.reagentMaterialNo == "" && this.materialBatchNo == "") return false;
    if (this.accountsSource == "shipments" && !this.dateFrom) return false;
    if (this.accountsSource == "shipments" && !this.dateTo) return false;
    if (this.contactsSource == "instrument" && this.instrumentMaterialNumber == "") return false;
    return true;
  }

  public onCheckValueChange(event: any, item: any) {
    item.checked = event.checked;
    if(item.checked === true){
      this.selectedData.push(item);
    }
    else if(item.checked === false){
      this.selectedData.pop(item);
    }else{
      return;
    }
  }

  public dateToFilter = (d: Date | null): boolean => {
    const dateTo = d || new Date();
    return dateTo >= this.dateFrom;
  }

  public onCancel(): void {
    this.cancelled = true;
    this.dialogRef.close('cancel');
  }

  public onImport(): void {
    this.dialogRef.close(this.selectedData);
  }

  public clearButton(id: any){
    const input = document.getElementById(id);
    if(id === 'datepickeFromFC' || id === 'datepickeToFC'){
      const dateChangeEvent = new Event('dateChange', { bubbles: true });
      input.dispatchEvent(dateChangeEvent);
    }else if(id.startsWith("reagentMatFC") || id.startsWith("batchNumFC") || id.startsWith("instruMatFC")){
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
    }else{
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
    }
  }

  public clearChildValue(filter){
    if(filter === 'affAccFC'){
      this.accountsSource = "none";
      if(this.showAccountsByIntrument && this.affAccFC.value === 'instrument'){
        this.instruMatFC.reset();
        this.materialNo = '';
      }

      this.reagentMaterialNo = '';

      this.batchNumFC.reset();
      this.batchNo = '';

      this.datepickeFromFC.reset();
      this.dateFrom = null;

      this.datepickeToFC.reset();
      this.dateTo = null;

      this.requestEnabled = this.isRequestEnabled();
    }
    if(filter === 'contactFC'){
      this.contactsSource = "none";

      if(((!this.showAccountsByIntrument && this.showContactsByInstrument) || this.affAccFC.value === null ) && this.contactFC.value === 'instrument'){
        this.instruMatFC.reset();
        this.materialNo = '';
      }

      this.attTypFC.reset();
      this.contactAttrType = "any";
      
      this.attValFC.reset();
      this.contactAttrValue = "";

      this.contRolFC.reset();
      this.contactRole = '';

      this.requestEnabled = this.isRequestEnabled();
    }
  }

  public addInstrumentField(){
    this.instrumentMaterials.push({ control: new FormControl('', [Validators.required]) });
  }

  public removeInstrumentField(index){
    if (this.instrumentMaterials.length > 1) {
      this.instrumentMaterials.splice(index, 1);
      this.instrumentMaterialNumber.splice(index, 1);
    }
  }

  public addReagentBatchField(){
    this.reagentMaterialBatchNumber.push({
      reagentMaterialNumber: new FormControl('', [Validators.required]),
      batchNumber: new FormControl('', [Validators.required])
    });
  }

  public removeReagentBatchField(index){
    if(this.reagentMaterialBatchNumber.length > 1){
      const materialNumber = this.reagentMaterialBatchNumber[index].reagentMaterialNumber.value;
      const batchValue = this.reagentMaterialBatchNumber[index].batchNumber.value;
      this.reagentMaterialBatchNumber.splice(index, 1);
      const materialIndex = this.reagentMaterialNo.indexOf(materialNumber);

      if (materialIndex >= 0) {
        this.reagentMaterialNo.splice(materialIndex, 1);
        this.reagentMaterialNoValue = this.reagentMaterialNo.filter(val => val && val.trim() !== '');
       // this.reagentMaterialNo = [...this.reagentMaterialNoValue];
      }
      const batchKey = `${materialNumber}|${batchValue}`;
      const batchIndex = this.materialBatchNo.indexOf(batchKey);

      if (batchIndex >= 0) {
        this.materialBatchNo.splice(batchIndex, 1);
        this.materialBatchNoValue = encodeURIComponent(this.materialBatchNo.filter(val => val && val.trim() !== ''));
        //this.materialBatchNo = [...this.materialBatchNoValue];
      }
    }
  }

public onReagentMaterialNoBatchNoValueChange(event: any, index: number) {
  const materialNumber = this.reagentMaterialBatchNumber[index]?.reagentMaterialNumber?.value || "";
  const batchValue = this.reagentMaterialBatchNumber[index]?.batchNumber?.value || "";

  if (materialNumber && batchValue) {
    const combinedKey = `${materialNumber}|${batchValue}`;
    this.materialBatchNo[index]= combinedKey;
    if (this.reagentMaterialNo[index] === materialNumber) {
     this.reagentMaterialNo[index] = null
    }
  } else if (materialNumber && !batchValue) {
   this.materialBatchNo = this.materialBatchNo.filter(key => {
      return !(key && key.startsWith(materialNumber + '|'));
    });
    this.reagentMaterialNo[index] = materialNumber;
  } else {
    this.materialBatchNo[index] = null;
    this.reagentMaterialNo[index] = null;
  }
  const reagentMaterialNoParam = this.reagentMaterialNo.filter(val => val && val.trim() !== '');
  const materialBatchNoParam =  this.materialBatchNo.filter(val => val && val.trim() !== '');
  this.reagentMaterialNoValue = reagentMaterialNoParam.join(',')
  this.materialBatchNoValue = encodeURIComponent(materialBatchNoParam.join(','))
  this.requestEnabled = this.isRequestEnabled();
}

  public onShipmentPartnerRoleChange(event: any){
    if ((event.includes('all') && this.checked == false) || (this.checked == false && event.length == 7)) {
      this.checked = true;
      this.shipPartnerRoleFC.setValue(this.allRoles);
      this.shipPartnerRole = "all"
    } else {
      if(!event.includes('all') && this.checked == true && event.length == 7){
        this.checked = false;
        this.shipPartnerRoleFC.setValue([])
        this.shipPartnerRole = []
      }else if(event.includes('all') && this.checked == true){
        this.checked = false;
        let arrdata = event.indexOf("all")
        event.splice(arrdata, 1);
        this.shipPartnerRoleFC.reset();
        this.shipPartnerRoleFC.setValue(event)
        this.shipPartnerRole = event
      }else{
        this.shipPartnerRoleFC.setValue(event);
        this.shipPartnerRole = event
      }
    }
  }

  public clearSelectedValue(clearValue){
      this.shipPartnerRoleFC.reset();
      this.shipPartnerRole = [];
  }

  public onDownload(): void {
    const downloadReport = this.dialog.open(FileFormatDialogComponent, { disableClose: true });
    downloadReport.afterClosed().subscribe(
      (res) => {
        if (res === 'csv') {
          this.csvData();
        }
        if (res === 'xlsx') {
          this.downloadExcel(this.selectedData, 'Notification Contacts');
        }
      },
      (error: HttpErrorResponse) => {
        this.oneSnackBar.open('Please try again later', OneSnackBarType.ERROR, '', { duration: 3000 });
      }
    );
  }

  downloadExcel(data, filename) {
    const wb = XLSX.utils.book_new();
    const contacts = data.map((row, index) => {
      const { checked, ...rest } = row;
      return { 'S.No': index + 1, ...rest };
    });
    const ws = XLSX.utils.json_to_sheet(contacts);
    XLSX.utils.book_append_sheet(wb, ws, 'CONTACTS');
    
    // Download File
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    const blob = new Blob([this.stringToArrayBuffer(wbout)], { type: 'application/octet-stream' });

    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);

    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute('target', '_blank');
    }

    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.xlsx');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  stringToArrayBuffer(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }

  downloadCSV(data, filename, headerList) {
    let csvData = this.formatCSV(data, headerList);
    let blob = new Blob(['\uFEFF' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  formatCSV(objArray, headerList) {
    let str = '';
    str += headerList + '\r\n';

    for (let i = 0; i < objArray.length; i++) {
      let line = '';
      line += objArray[i] || '';
      str += line + '\r\n';
    }

    let res = '';
    res = 'SEP=,' + '\r\n' + str;

    return res;
  }

  csvData(){
    const contacts = this.selectedData.map((row, index) => {
      const { checked, ...rest } = row;
      return { 'S.No': index + 1, ...rest };
    });

    let headers = contacts.map((item) => Object.keys(item).toString());
    headers = Array.from(new Set(headers));
    
    const values = contacts.map((item) => {
      return Object.values(item).map(value => {
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          const escapedValue = value.replace(/"/g, '""');
          return `"${escapedValue}"`;
        }
        return value;
      }).join(',');
    });
    
    this.downloadCSV(values, 'Notification Contacts', headers);
  }

  public isAllSelected(){
  const selected = this.shipPartnerRoleFC.value || [];
  return selected.length === this.allRoles.length || selected.includes('all');
}

public selectedRolesDisplay(){
  if (this.isAllSelected()) {
    this.checked = true;
    return 'All';
  }
  return (this.shipPartnerRoleFC.value || []).map((v: string) => v.toUpperCase()).join(', ');
}

}